import { calcUrl } from "@/features/ui/helpers/fetcher-helpers";
import useYWR, { YWRKey } from "@/features/ui/hooks/use-ywr";
import { UrlParser } from "@/features/ui/helpers/url-parser";
import { StringTransformer } from "@/features/ui/helpers/string-transformer";
import useFetcher from "@/utils/use-fetcher";

// 오더룰(컨디션) 적용 상태.
//  PENDING       대기 — 아직 적용하지 않음
//  APPLIED       적용 완료 (적용 시각이 함께 기록된다)
//  SKIPPED       적용하지 않고 넘어감
//  NO_ORDER_RULE 적용할 오더룰 없음
export type OrderRuleStatus =
  | "PENDING"
  | "APPLIED"
  | "SKIPPED"
  | "NO_ORDER_RULE";

export interface UpdateOrderRuleStatusRequest {
  status: OrderRuleStatus;
}
export interface UpdateOrderRuleStatusResponse {}
export interface UpdateOrderRuleStatusParameter {
  agencyId: number;
  lineSheetSetId: number;
}

export const updateOrderRuleStatusTemplateUrl =
  "/agencies/:agencyId/line-sheet-sets/:lineSheetSetId/apply_condition";

export const updateOrderRuleStatusKey: YWRKey<UpdateOrderRuleStatusParameter> = {
  url: (parameter) => {
    return calcUrl(updateOrderRuleStatusTemplateUrl, parameter);
  },
  method: "post",
};

export function parseUpdateOrderRuleStatusKey(url: string) {
  const urlParser = new UrlParser<UpdateOrderRuleStatusParameter>(
    updateOrderRuleStatusTemplateUrl,
    {
      agencyId: StringTransformer.parseId,
      lineSheetSetId: StringTransformer.parseId,
    }
  );
  return {
    parameter: urlParser.parse(url),
    method: "post",
  };
}

export default function useUpdateOrderRuleStatus() {
  const fetcher = useFetcher<
    UpdateOrderRuleStatusRequest,
    UpdateOrderRuleStatusResponse
  >();
  return useYWR(updateOrderRuleStatusKey, fetcher);
}
